export const PAYMENT_METHODS = {
  CREDIT_DEBIT_WITH_CHECKOUT: 'CreditDebitWithCheckout',
  TABBY: 'Tabby',
};

export const CAPTCHA_TOKEN_KEY = 'captchaToken';
